export enum BudgetDecision {
  APPROVE = "APPROVE",
  REJECT = "REJECT",
  COUNTER_PROPOSE = "COUNTER_PROPOSE",
}
